import { truncate } from 'lodash';

export default (address: string, length = 9, omission = '...') =>
    address?.length > 0
        ? `${truncate(address, {
              length,
              omission,
          })}${address?.substr(address?.length - 4)}`
        : '';
